<div class="container">
    <div class="row">
        <div class="col-xs-12" *ngIf="!loadingUserDetailsFlag">
            <div class="row">
                <div class="col-xs-12">
                    <form #makeEmployeeForm="ngForm" name="makeEmployeeForm" novalidate>
                        <div class="row">
                            <div class="col-xs-12 job-match-status-statement">
                                <div style="font-size: 1.2em">
                                    Make User
                                    <span class="emerald">{{userObject && userObject.userDetails ? userObject.userDetails.name : ''}}</span>
                                    an Employee
                                </div>
                                <div class="alert alert-danger" style="margin-top: 10px; border-radius: 5px; margin-bottom: 0px;">
                                    <span class="fas fa-exclamation-triangle" style="margin-right: 5px;"></span>
                                    This User will no longer have login access to the application. This User will be removed from all "Active" requisitions.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group pt-3" [ngClass]="{'has-error': (makeEmployeeForm.submitted && organizationalManager.invalid)}">
                                    <label for="organizationalManager" class="control-label">
                                        Choose Manager<em> * </em> :
                                    </label>
                                    <tag-input
                                        #organizationalManager="ngModel"
                                        name="organizationalManager"
                                        class="make-employee-user"
                                        [ngClass]="{'has-tags': selectedOrganizationalManagerObjectsArray.length}"
                                        [(ngModel)]="selectedOrganizationalManagerObjectsArray"
                                        [identifyBy]="'id'"
                                        [displayBy]="'name'"
                                        [placeholder]="'Type name to search for user.'"
                                        [secondaryPlaceholder]="'Type name to search for user.'"
                                        [maxItems]="1"
                                        [onlyFromAutocomplete]="true"
                                        [disabled]="makingEmployeeFlag"
                                        (onAdd)="organizationalManagerTypeAheadManagerAdded($event)"
                                        (onRemove)="organizationalManagerTypeAheadManagerRemoved($event)"
                                        required>
                                        <ng-template let-item="item" let-index="index">
                                            <span class="px-3 d-block d-flex">
                                                <span class="pr-3 d-block">{{ item.name.length > 40 ? (item.name.substring(0, 40) + "...") : item.name }}</span>
                                                <delete-icon style="width: 12px; height: 12px;"
                                                    (click)="removeItem(item, index)">
                                                </delete-icon>
                                            </span>
                                        </ng-template>
                                        <tag-input-dropdown
                                            [identifyBy]="'id'"
                                            [displayBy]="'name'"
                                            [showDropdownIfEmpty]="true"
                                            [autocompleteObservable]="getOrganizationalManagers"
                                            [limitItemsTo]="1000">
                                            <ng-template let-item="item" let-index="index">
                                                {{ item.name }}
                                            </ng-template>
                                        </tag-input-dropdown>
                                    </tag-input>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group" [ngClass]="{'has-error': (makeEmployeeForm.submitted && title.invalid)}">
                                    <label for="title" class="control-label">
                                        Title<em> * </em> :
                                    </label>
                                    <input
                                        #title="ngModel"
                                        type="text"
                                        class="form-control access"
                                        name="title"
                                        id="title"
                                        [(ngModel)]="userToEmployeeObject.title"
                                        [disabled]="makingEmployeeFlag"
                                        required>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 20px; padding: 10px;">
                            <div class="col-xs-12 text-right clearfix">
                                <button type="button" class="btn btn-danger" style="margin-right: 5px;"
                                    [disabled]="makingEmployeeFlag" (click)="cancel()">
                                    <span>Cancel</span>
                                </button>
                                <button type="submit" class="btn btn-primary pull-right"
                                    [disabled]="makingEmployeeFlag" (click)="convertToEmployee()">
                                    <span *ngIf="!makingEmployeeFlag">Make Employee</span>
                                    <span *ngIf="makingEmployeeFlag">Making Employee ..</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-xs-12 d-flex justify-content-center align-items-center" *ngIf="loadingUserDetailsFlag">
            <div>
                Loading.. <span class="fas fa-spin fa-spinner"></span>
            </div>
        </div>
    </div>
</div>
